import CommonStore from "../common_store";
import { action, makeObservable, observable, runInAction } from "mobx";
import api from "../../../api";
import { DatePickerProps, message, Modal, UploadFile } from "antd";
import { RangePickerProps } from "antd/es/date-picker";
import dictionary from "../../../utils/dictionary";

class SignatureManageStore {
  commonStore?: CommonStore;

  constructor(baseStore?: CommonStore) {
    this.commonStore = baseStore;
    makeObservable(this);
  }
  @observable searchForm: any = {};
  @observable tableData: any = {};
  //表格加载状态
  @observable tableLoad: boolean = true;
  //分页信息
  @observable pageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageData.page = page;
        this.pageData.size = size;
        this.pageData = { ...this.pageData };
      });
      this.getSignaturePage();
    },
  };

  @observable isOpenDetail: boolean = false; //控制查看详情弹框
  @observable detailData: any = {}; //查看详情数据
  @observable getAllEnumList: any = [];
  // @observable getAllEnumListFind: any = []; //获取所有签名不包含填写新签名

  @observable socialCreditCertificateObjectNamesUrl: any = []; //模板变量承诺文件地址
  @observable orderVoucherObjectNamesUrl: any = []; //模板变量承诺文件地址
  @observable signAuthzCertificateObjectNamesUrl: any = []; //模板变量承诺文件地址

  @observable modalLoading: boolean = false;
  //控制查看详情弹框
  closeDetailModal(record?: any) {
    runInAction(() => {
      this.isOpenDetail = false;
      this.socialCreditCertificateObjectNamesUrl = [];
      this.orderVoucherObjectNamesUrl = [];
      this.signAuthzCertificateObjectNamesUrl = [];
    });
  }
  //控制查看详情弹框
  async openDetailModal(record: any) {
    await this.getFileUrl(record)
      .then(() => {
        runInAction(() => {
          this.detailData = record;
          this.isOpenDetail = true;
        });
      })
      .catch((e: any) => {});
  }

  setSearchForm(obj: any) {
    runInAction(() => {
      this.searchForm = obj;
    });
  }

  //重置分页
  resetPage() {
    runInAction(() => {
      this.pageData.page = 1;
    });
  }

  //分页查询
  @action
  getSignaturePage() {
    this.commonStore?.getPagePermission("calling_card_signature_management");
    this.getAllEnum();
    runInAction(() => {
      this.tableData = {};
      this.tableLoad = true;
    });
    const data = { ...this.searchForm };
    data.size = this.pageData.size;
    data.page = this.pageData.page;
    api.signatureApi
      .getSignaturePage(data)
      .then((res: any) => {
        if (res.code == 200) {
          runInAction(() => {
            this.tableData = res.data;
            this.tableData = { ...this.tableData };
            this.tableLoad = false;
          });
        }
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false;
        });
      });
  }

  @action
  getAllEnum() {
    api.signatureApi
      .getAllEnum()
      .then((res: any) => {
        runInAction(() => {
          this.getAllEnumList = res.data;
          // let newArray = this.getAllEnumList.slice();
          // newArray.shift();
          // this.getAllEnumListFind = newArray;
        });
      })
      .catch((e: any) => {});
  }

  //获取临时下载地址,
  @action
  async getFileUrl(data: any) {
    if (data.socialCreditCertificateObjectNames) {
      data.socialCreditCertificateObjectNames.map(async (item: any) => {
        await api.templateApi
          .temporaryDown(item)
          .then((res: any) => {
            runInAction(() => {
              this.socialCreditCertificateObjectNamesUrl.push({
                url: res.data,
                fileName: item,
              });
            });
          })
          .catch((err: any) => {});
      });
    }
    if (data.orderVoucherObjectNames) {
      data.orderVoucherObjectNames.map(async (item: any) => {
        await api.templateApi
          .temporaryDown(item)
          .then((res: any) => {
            runInAction(() => {
              this.orderVoucherObjectNamesUrl.push({
                url: res.data,
                fileName: item,
              });
            });
          })
          .catch((err: any) => {});
      });
    }
    if (data.signAuthzCertificateObjectNames) {
      data.signAuthzCertificateObjectNames.map(async (item: any) => {
        await api.templateApi
          .temporaryDown(item)
          .then((res: any) => {
            runInAction(() => {
              this.signAuthzCertificateObjectNamesUrl.push({
                url: res.data,
                fileName: item,
              });
            });
          })
          .catch((err: any) => {});
      });
    }
  }


  @action
  signatureDelete(no: string) {
    api.signatureApi
      .signatureDelete(no)
      .then((res: any) => {
        message.success("删除成功");
        this.resetPage();
        this.getSignaturePage();
      })
      .catch((e: any) => {});
  }

  //删除
  deletePower(no: string) {
    return new Promise((resolve, reject) => {
      Modal.confirm({
        centered: true,
        title: "确认删除",
        content: "请注意：删除后，签名关联的所有模版将无法使用。",
        okText: "继续删除",
        cancelText: "操作取消",
        onOk: () => {
          this.signatureDelete(no);
          return resolve(true);
        },
        onCancel: () => {
          return false;
        },
      });
    });
  }
}

export default SignatureManageStore;
